/*
  MAISON FERMOIR (21/10/2026) — l'offre « 2e collier à -50 % / 3e offert » se compose À LA MAIN.

  Le sélecteur natif de Fullstack (bloc « Réduction sur quantité », classe `mf-offre` sur la fiche)
  ajoutait 2 ou 3 fois LE MÊME collier : la cliente se retrouvait avec trois perles identiques dans
  le tiroir. Demande de Mika : elle ajoute son 2e et son 3e collier elle-même.

  Ce script, sans toucher aux fichiers du thème (écrasés à chaque mise à jour de Fullstack) :
  1. Fiche : le bouton n'ajoute que CE collier, au prix d'un seul collier, quelle que soit la carte
     choisie ; une ligne sous les cartes dit que la suite se choisit dans le panier.
  2. Tiroir : tant que le nombre de colliers payants est sous l'offre choisie, la classe
     `mf-offre-guide` sur <cart-drawer> montre les suggestions (téléphone compris) sous le titre
     « Choisissez votre 2e collier… » (CSS dans mf-charte.css, § L'OFFRE DANS LE TIROIR).
     L'offre visée vit dans sessionStorage, la classe sur l'élément <cart-drawer> lui-même : son
     contenu est remplacé à chaque mise à jour du panier, lui ne l'est pas.
  Les remises restent celles de Shopify (proteus/offre_colliers.py), sur le collier le moins cher.
*/
(() => {
  const CLE = 'mf_offre_cible';
  const en = (document.documentElement.lang || '').toLowerCase().startsWith('en');
  const T = en
    ? {
        suite2: 'Add this necklace: the basket then suggests your 2nd one.',
        suite3: 'Add this necklace: the basket then suggests the other 2.',
        guide2: 'Choose your 2nd necklace: it is half price',
        guide3: 'Choose your 3rd necklace: it is free',
      }
    : {
        suite2: 'Ajoutez ce collier : le panier vous propose ensuite le 2e.',
        suite3: 'Ajoutez ce collier : le panier vous propose ensuite les 2 autres.',
        guide2: 'Choisissez votre 2e collier : il est à -50 %',
        guide3: 'Choisissez votre 3e collier : il est offert',
      };

  const lire = () => {
    try { return parseInt(sessionStorage.getItem(CLE), 10) || 0; } catch (e) { return 0; }
  };
  const ecrire = (n) => {
    try { n ? sessionStorage.setItem(CLE, String(n)) : sessionStorage.removeItem(CLE); } catch (e) {}
  };

  // Quantité de la carte choisie sur la fiche (1, 2 ou 3).
  const offreChoisie = () => {
    const carte = document.querySelector('quantity-breaks.mf-offre .quantity-break--selected');
    return parseInt(carte?.dataset.quantity, 10) || 1;
  };

  // 1. Fiche ------------------------------------------------------------------------------------
  customElements.whenDefined('quantity-breaks').then(() => {
    const QB = customElements.get('quantity-breaks');
    if (QB.prototype.__mfOffre) return;
    QB.prototype.__mfOffre = true;
    const items = QB.prototype.getSelectedItems;
    const prix = QB.prototype.getPrices;
    const remise = QB.prototype.getDiscount;
    const premiere = (qb) => qb.quantity_break_items?.[0];

    QB.prototype.getSelectedItems = function () {
      const liste = items.call(this);
      if (this.classList.contains('mf-offre') && !this.isVariantSelectorActivated() && liste[0]) {
        liste[0] = { ...liste[0], quantity: 1 };
      }
      return liste;
    };
    QB.prototype.getPrices = function () {
      return this.classList.contains('mf-offre') && premiere(this) ? premiere(this).getPrices() : prix.call(this);
    };
    QB.prototype.getDiscount = function () {
      return this.classList.contains('mf-offre') && premiere(this) ? premiere(this).getDiscount() : remise.call(this);
    };
  });

  const poserSuite = () => {
    const qb = document.querySelector('quantity-breaks.mf-offre');
    if (!qb) return;
    let p = qb.parentElement.querySelector(':scope > .mf-offre-suite');
    if (!p) {
      p = document.createElement('p');
      p.className = 'mf-offre-suite';
      qb.after(p);
    }
    const n = offreChoisie();
    p.textContent = n >= 3 ? T.suite3 : n === 2 ? T.suite2 : '';
    p.hidden = n < 2;
  };
  document.addEventListener('quantity-breaks:updated', poserSuite);
  // La carte se coche au premier rendu sans événement : on attend que le composant soit monté.
  customElements.whenDefined('quantity-breaks').then(() => requestAnimationFrame(poserSuite));

  // 2. Tiroir -----------------------------------------------------------------------------------
  const colliersPayants = async () => {
    const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    const panier = await r.json();
    // Le bracelet du palier 79 € est une ligne à 0 € : il ne compte pas comme un collier.
    return panier.items.reduce((n, l) => n + (l.original_price > 0 ? l.quantity : 0), 0);
  };

  const guider = async () => {
    const tiroir = document.querySelector('cart-drawer');
    if (!tiroir) return;
    const cible = lire();
    let n = 0;
    if (cible >= 2) {
      try { n = await colliersPayants(); } catch (e) { return; }
    }
    const actif = cible >= 2 && n >= 1 && n < cible;
    if (cible >= 2 && !actif) ecrire(0);
    tiroir.classList.toggle('mf-offre-guide', actif);
    if (actif) tiroir.style.setProperty('--mf-offre-titre', JSON.stringify(n === 1 ? T.guide2 : T.guide3));
  };

  document.addEventListener('cart:updated', (e) => {
    // Ajout depuis la fiche : l'offre choisie devient la cible du tiroir.
    if (e.detail?.data?.source === 'product-form' && document.querySelector('quantity-breaks.mf-offre')) {
      const n = offreChoisie();
      if (n >= 2) ecrire(n);
    }
    guider();
  });
  document.addEventListener('DOMContentLoaded', guider);
  if (document.readyState !== 'loading') guider();
})();
